import React, { Component } from 'react'
import loading from '../loading.gif'
export default class Loading extends Component {
  render () {
    return (
      <img src={loading} alt="Loading..." style={{ width: '50px', height: '50px' }} />
    )
  }
}
